import { ProductSelectEvent } from '@shopify/events';

class FandomRestock extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const scope = this.closest('.shopify-section') || document;
    const signal = this.controller.signal;
    scope.addEventListener(ProductSelectEvent.eventName, async (event) => {
      try {
        const result = await event.promise;
        const variant = result?.detail?.resource;
        if (this.isConnected && variant?.id) this.syncVariant(String(variant.id));
      } catch {}
    }, { signal });
    scope.addEventListener('change', (event) => {
      if (this.contains(event.target)) return;
      const input = event.target;
      const variant = input.dataset?.variantId || input.selectedOptions?.[0]?.dataset.variantId;
      if (variant) this.syncVariant(variant);
    }, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  syncVariant(id) {
    const select = this.querySelector('select[name="contact[Requested variant]"]');
    const option = [...(select?.options || [])].find((item) => item.dataset.variantId === id);
    if (option) {
      select.value = option.value;
      this.querySelector('details').open = true;
    }
  }
}

if (!customElements.get('fandom-restock')) customElements.define('fandom-restock', FandomRestock);
